import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { formatDate } from '@angular/common';
import Swal from 'sweetalert2';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';       /// Change Language
import { Router } from '@angular/router';
import { LkpRevenueService } from 'src/app/services/LkpRevenueService';
import { RoomsModel } from 'src/app/models/RoomsModel';
import { LkpBanksModel } from 'src/app/models/LkpBanksModel';
import { LkpRevenueModel } from 'src/app/models/LkpRevenueModel';
import swal from 'sweetalert2';
import { RevenueTypesSearchComponent } from '../revenue-types-search/revenue-types-search.component';

@Component({
  selector: 'app-revenue-types',
  templateUrl: './revenue-types.component.html',
  styleUrls: ['./revenue-types.component.css']
})
export class RevenueTypesComponent implements OnInit {
  revcode = '' ;
  revname = '' ;
  revnotes = '' ;
  compcode = '' ;
  userid = '' ;
  modifieddate = '2024-01-01' ;

  constructor(public revenueervice : LkpRevenueService,
              public revneue : LkpRevenueModel,
              public translate: TranslateService,
              public storage: LocalStorageService,
              private dialogref: MatDialog
    ) { }

  ngOnInit(): void {
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchArabic(){
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchEnglish(){
    this.translate.use('en');
    document.documentElement.dir = "ltr";
  }
  openDialog(){
    const dialogRef = this.dialogref.open(RevenueTypesSearchComponent,
      {
        data: {
          dataKey: this.revneue
        }
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.revcode = result.revcode;
        this.revname = result.revname;
        this.revnotes = result.revnotes;
        dialogSubmitSubscription.unsubscribe();
      });

  }

  retriveSRevenue(){
    this.revenueervice.getRevenue(this.revcode, this.storage.retrieve('stgcompCode')).subscribe(
      (data: LkpRevenueModel) => {

        this.revname = data.revname;
        this.revnotes = data.revnotes;
        this.userid = data.userid;
        this.modifieddate = data.modifieddate;
        this.compcode = data.compcode;

      }
    );
  }
  submitRevenue(){
    if (this.revcode == '' || this.revcode == null) {
      return;
    }

    this.revneue.revcode = this.revcode;
    this.revneue.revname = this.revname;
    this.revneue.revnotes = this.revnotes;

    this.revneue.userid = this.storage.retrieve('stguserId');
    this.revneue.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.revneue.compcode = this.storage.retrieve('stgcompcode');
    this.revenueervice.AddRevenue(this.revneue).subscribe(data => {
    this.mesgSave();
    },
      error => { alert(error); }
    );
  }
  DeleteRevenue(){
    this.revenueervice.DelRevenue(this.revcode, this.storage.retrieve('stgcompCode')).subscribe(
      (data: LkpRevenueModel) => {
      }
    );
    this.NewData();
  }
  MesgDelete(){
    swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(
      () => {
        this.DeleteRevenue();
        swal('Deleted!', 'Your record has been deleted.', 'success');
      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
  NewData(){
    this.revcode = '';
    this.revname='';
    this.revnotes='';
  }
  mesgSave() {
    Swal({
    title: 'Your work has been saved',

    type: 'success',
    showConfirmButton: false,

    timer: 1500
    });
  }

}
